// Dashboard translations. Strings are written in English in the code and wrapped in tr();
// the English text is the key, so a missing translation simply shows English.
// Hebrew switches the whole layout to right-to-left.
import core from "./i18n/he/core.json";
import shell from "./i18n/he/shell.json";
import pagesA from "./i18n/he/pages-a.json";
import pagesB from "./i18n/he/pages-b.json";
import pagesC from "./i18n/he/pages-c.json";
import billing from "./i18n/he/billing.json";
import setup from "./i18n/he/setup.json";
import knowledge from "./i18n/he/knowledge.json";
import configChat from "./i18n/he/config-chat.json";
import guides from "./i18n/he/guides.json";
import email from "./i18n/he/email.json";
import contactImport from "./i18n/he/import.json";
import alerts from "./i18n/he/alerts.json";
import growth from "./i18n/he/growth.json";
import academy from "./i18n/he/academy.json";
import calls from "./i18n/he/calls.json";
import siteLibrary from "./i18n/he/site-library.json";
import missedCalls from "./i18n/he/missed-calls.json";

import workflow from "./i18n/he/workflow.json";

const LANG_KEY = "rz.lang";
const DICTS = { he: { ...core, ...shell, ...pagesA, ...pagesB, ...pagesC, ...billing, ...setup, ...knowledge, ...configChat, ...guides, ...email, ...contactImport, ...alerts, ...growth, ...academy, ...calls, ...siteLibrary, ...missedCalls, ...workflow } };
export const LANGS = [
  { code: "en", label: "English" },
  { code: "he", label: "עברית" },
];

function initialLang() {
  // The Android app always opens the dashboard with ?lang=, its own language, so both views agree. It
  // is stored like a choice made here, and dropped from the address so a later switch's reload keeps it.
  const fromUrl = new URLSearchParams(location.search).get("lang");
  if (fromUrl === "he" || fromUrl === "en") {
    const url = new URL(location.href);
    url.searchParams.delete("lang");
    history.replaceState(null, "", url.pathname + url.search + url.hash);
    try {
      localStorage.setItem(LANG_KEY, fromUrl);
    } catch {
      /* private mode */
    }
    return fromUrl;
  }
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved === "he" || saved === "en") return saved;
  } catch {
    /* private mode */
  }
  return (navigator.language || "").toLowerCase().startsWith("he") ? "he" : "en";
}

let lang = initialLang();

export function getLang() {
  return lang;
}

/** BCP 47 locale for Intl formatting in the current language. */
export function locale() {
  return lang === "he" ? "he-IL" : "en-GB";
}

export function applyLang() {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "he" ? "rtl" : "ltr";
}

/** Switches language and reloads, so every component re-renders in the new language and direction. */
export function setLang(next) {
  try {
    localStorage.setItem(LANG_KEY, next);
  } catch {
    /* private mode */
  }
  // Inside the Android app, its own screens switch too (LanguageBridge in DashboardScreen.kt). An app
  // from before the bridge has no window.RelayzaApp and simply reloads, as on the web.
  try {
    window.RelayzaApp?.setLanguage(next);
  } catch {
    /* the app refused; the page still switches */
  }
  location.reload();
}

/**
 * Translates an English UI string. `vars` fill {placeholders}: tr("{n} sent", { n: 3 }).
 * Never pass user content (names, messages) as the key; pass it through vars instead.
 */
export function tr(en, vars) {
  let s = (lang !== "en" && DICTS[lang]?.[en]) || en;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v ?? ""));
  return s;
}

